<template>
	<div class="container">
		<!-- <apexchart width="500" type="line" :options="options" :series="series"></apexchart> -->

		<headMenu @load="(e)=>{D = e}" />
		<part1 />
		<router-link to="/signupTeacher">
			<img 
			:src="require('../../../assets/img/baner_sm.gif')"
			alt="ایزی تیک بهینه، به صرفه، همراه اساتید"
			title="ایزی تیک بهینه، به صرفه، همراه اساتید"
			class="d-sm-block d-md-none w-100"
			/>
			<img 
			:src="require('../../../assets/img/baner_md.gif')"
			alt="ایزی تیک بهینه، به صرفه، همراه اساتید"
			title="ایزی تیک بهینه، به صرفه، همراه اساتید"
			class="d-none d-md-block d-lg-none w-100"
			/>
			<img 
			:src="require('../../../assets/img/baner_lg.gif')"
			alt="ایزی تیک بهینه، به صرفه، همراه اساتید"
			title="ایزی تیک بهینه، به صرفه، همراه اساتید"
			class="d-none d-lg-block w-100"
			/>
		</router-link>
		<part11 :flds="D" />
		<part12 :data="social_network.data.social_network" v-if="social_network.ok" />
		<!-- ------------------------------------------------------------- -->
		<div class="w-100 text-center">
			<img width="30px"
			alt="ticket.siadat.net"
			title="ticket.siadat.net"
			:src="require('../../../assets/img/Shape_Title.svg')"
			data-aos="flip-up" data-aos-easing="ease-out-cubic" data-aos-duration="2000" />
		</div>
		<!-- ------------------------------------------------------------- -->
		<div class="text-left" style="position: absolute; left: 0;" data-aos="fade-down" data-aos-duration="3000">
			<img width="100px"
			alt="ticket.siadat.net"
			title="ticket.siadat.net"
			:src="require('../../../assets/img/Home_Shape_3.svg')"
			data-aos="flip-down" data-aos-easing="ease-out-cubic" data-aos-duration="2000" />
		</div>
		<!-- ------------------------------------------------------------- -->
		<part2 />
		<!-- ------------------------------------------------------------- -->
		<part3 />
		<!-- ------------------------------------------------------------- -->
		<part4 :category="category.data" v-if="category.ok" />
		<!-- ------------------------------------------------------------- -->
		<br/>
		<br/>
		<br/>
		<br/>
		<div class="w-100 text-center">
			<img width="30px"
			alt="ticket.siadat.net"
			title="ticket.siadat.net"
			:src="require('../../../assets/img/Shape_Title.svg')"
			data-aos="flip-down" data-aos-easing="ease-out-cubic" data-aos-duration="2000"
			/>

		</div>
		<!-- ------------------------------------------------------------- -->
		<part5 :teachers="teachers.data" v-if="teachers.ok" />
		<!-- ------------------------------------------------------------- -->
		<br/>
		<br/>
		<br/>
		<br/>
		<div class="w-100 text-center">
			<img width="30px"
			alt="ticket.siadat.net"
			title="ticket.siadat.net"
			:src="require('../../../assets/img/Shape_Title.svg')"
			data-aos="flip-down" data-aos-easing="ease-out-cubic" data-aos-duration="2000" />
		</div>
		<!-- ------------------------------------------------------------- -->
		<part6 v-if="windowWidth > 1000" />
		<!-- ------------------------------------------------------------- -->
		<br/>
		<br/>
		<br/>
		<br/>
		<!-- ------------------------------------------------------------- -->
		<part7 />
		<!-- ------------------------------------------------------------- -->
		<br/>
		<br/>
		<br/>
		<br/>
		<div class="w-100 text-center">
			<img width="30px"
			alt="ticket.siadat.net"
			title="ticket.siadat.net"
			:src="require('../../../assets/img/Shape_Title.svg')"
			data-aos="flip-down" data-aos-easing="ease-out-cubic" data-aos-duration="2000" />
		</div>
		<!-- <part8 v-if="degrees.ok" :flds="degrees.data" /> -->
		<!-- ------------------------------------------------------------- -->
		<part81 :auditors="auditors.data" v-if="auditors.ok" />
		<!-- ------------------------------------------------------------- -->
		<part82 :data="social_network.data.social_network" v-if="social_network.ok" />
		<!-- ------------------------------------------------------------- -->
		<br/>
		<br/>
		<br/>
		<br/>
		<div class="w-100 text-center" >
		</div>
		<part9 v-if="degrees.ok && social_network.ok" :flds="degrees.data" :data="social_network.data.social_network" />
		<!-- ------------------------------------------------------------- -->
		<div class="text-center">
			2023 تمامی حقوق محفوظ است. فناوری رهنمای دنیای آینده (فردا)
		</div>
	</div>
</template>

	<script>
	// import VueApexCharts from 'vue-apexcharts'

		import myketir from '../../../assets/img/myketir.png';

		import headMenu from  "../../../menu/headMenu.vue";
		import part1 from  "./home_part1.vue";
		import part11 from  "./home_part1_1.vue";
		import part12 from  "./home_part1_3.vue";
		import part2 from  "./home_part2.vue";
		import part3 from  "./home_part3.vue";
		import part4 from  "./home_part4.vue";
		import part5 from  "./home_part5.vue";
		import part6 from  "./home_part6.vue";
		import part7 from  "./home_part7.vue";
		import part81 from  "./home_part8_1.vue";
		import part82 from  "./home_part8_2.vue";
		import part9 from  "./home_part9.vue";
		export default {
			name: 'home_main',
			data(){
				return {
	// 				options: {
    //     chart: {
    //       id: 'vuechart-example'
    //     },
    //     xaxis: {
    //       categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
    //     }
    //   },
    //   series: [{
    //     name: 'series-1',
    //     data: [30, 40, 45, 50, 49, 60, 70, 91]
    //   }],


					imgurl: window.imgurl,
					baseurl: window.baseurl,
					categoryOK: false,
					teachersOK: false,
					category: {"ok": false,},
					social_network: {"ok": false,},
					teachers: {"ok": false,},
					degrees: {"ok": false,},
					D: {"ok": false,},
					auditors: {"ok": false,},
					img: {
							"myketir": myketir,
							"bg": '',
					},
				}
			},
			components: {
				headMenu,
				part1,
				part11,
				part12,
				part2,
				part3,
				part4,
				part5,
				part6,
				part7,
				part81,
				part82,
				part9,
			},
			props: [],
			mounted(){
				this.$swal.close();
				(this.chechRole()) ? this.getCategory(this) : this.$router.push('/reserved/user/list');
			},
			methods:{
				chechRole(){
					let user = this.$localStorage.get('user');
					if(user == null){
							return true;
					}else if(user.username.role != 3){
							return true;
					}else{
							return false;
					}
				},
				getCategory(THIS){
					if(!this.teachers.ok){
						window.$.get(this.baseurl + 'category/list', { sort: "id:asc" }, function(D){
							THIS.category = D;
							THIS.getTeachers(THIS);
						}, "json");
					}
				},
				getTeachers(THIS){
					window.$.get(this.baseurl+'view/teachers/best', { }, function(D){
						THIS.teachers = D;
					}, "json");
					THIS.getHightlightsDegrees(THIS);
				},
				getHightlightsDegrees(THIS){
					window.$.get(this.baseurl+'degrees/hightlights', { }, function(D){
							THIS.degrees = D;
						THIS.getAuditors();
					}, "json");
				},
				getAuditors(THIS = this){
					window.$.post(this.baseurl+"auditors/list", { token: this.$localStorage.get("user"), role: 1 }, function(D){
						THIS.auditors = D;
						THIS.get_social_network();
					}, "json");
				},
				get_social_network(THIS = this){
					window.$.post(this.baseurl+"all/public", {token: this.$localStorage.get("user"), }, function(D){
						THIS.social_network = D;
					}, "json");
				},
			}
		}
	</script>
<style>

</style>
